<template>
    <div class="main-cn">
        <div class="main-bd mg20">
            <el-tabs v-model="searcherModel.active_name" @tab-click="handleClick" v-if="this.$route.path == '/customers/index'" v-loading="loading">
                <el-tab-pane label="全部客户" name="index"></el-tab-pane>
                <el-tab-pane label="协作客户" name="cooperator"></el-tab-pane>
            </el-tabs>
            <el-tabs v-model="searcherModel.active_name" @tab-click="handleClick" v-else-if="this.$route.path == '/customers/public'" v-loading="loading">
                <el-tab-pane label="公海池" name="public"></el-tab-pane>
                <el-tab-pane label="回收站" name="recycle" v-if="Acs('/customers/recycle-list')"></el-tab-pane>
            </el-tabs>
            <div v-if="searcherModel.active_name == 'recycle'">
                <Recycle></Recycle>
            </div>
            <div v-else>
                <el-row class="searchSection">
                    <SearchForm
                        :params="searcherModel"
                        :fields="fields"
                        :cache_field="'search_customer_config_' + searcherModel.active_name + '_' + this.$route.path"
                        @search="submitSearch"
                        @reset="resetForm"
                        :key="search_form_key">
                    </SearchForm>
                </el-row>
                <el-row class="addBtn">
                    <template v-if="searcherModel.active_name != 'cooperator'">
                        <el-button :disabled="disableBatchOption" v-if="Acs('customers-batch-bind')" type="primary" size="small" @click="showBatchBindDialog(1)">批量绑定</el-button>
                        <el-button :disabled="disableBatchOption" type="warning" size="small" v-if="Acs('/customers/unbind') && this.$route.path != '/customers/public'" @click="showBatchUnbindDialog()">批量解绑</el-button>
                        <el-button :disabled="disableBatchOption" type="danger" size="small" @click="showBatchDeleteDialog()" v-if="Acs('/customers/delete')">批量删除</el-button>
                        <el-button type="success" size="small" v-if="Acs('/customers/create') && this.$route.path != '/customers/public'" @click="addCustomer()">+ 新增客户</el-button>
                        <el-button type="primary" size="small"  v-if="Acs('/sales-leads/query-repeat')"  @click="showQueryRepeat = true">数据查重</el-button>
                        <el-button :disabled="disableBatchOption" v-if="Acs('/customers/merge') && this.$route.path == '/customers/index'" type="warning" size="small" @click="showBatchMergeDialog()">合并客户</el-button>
                        <el-button :disabled="disableBatchOption" v-if="Acs('/customers/change-area') && this.$route.path == '/customers/index'" type="danger" size="small" @click="showBatchDistrictDialog()">批量修改客户地区</el-button>
                        <el-button :disabled="disableBatchOption" v-if="Acs('/customers/take-over')" type="primary" size="small" @click="showBatchBindDialog(2)">批量转交客户</el-button>
                        <el-button v-if="Acs('/customer-cooperator/import-cooprator')" type="primary" size="small" @click="showImportCooperatorDialog">导入协作人</el-button>
                    </template>
                    <ExportFile
                        v-if="Acs('/customers/export')"
                        :url="'/api/customers/export'"
                        :params="searcherModel"
                        filename="客户数据表"
                        buttonName="客户导出"
                        buttonType="success">
                    </ExportFile>
                </el-row>

                <el-table :data="customers" class="tabTopBorder" v-loading="loading" @sort-change="submitSearch(null, $event)" @selection-change="handleSelectionChange">
                    <el-table-column prop="id" type="selection" width="50"></el-table-column>
                    <el-table-column label="客户ID" prop="id" width="80"></el-table-column>
                    <el-table-column label="客户名称" prop="name">
                        <template slot-scope="scope">
                            <span class="el-dropdown-link customer-name">
                                <router-link target="_blank" :to="{path: '/customers/view', query: {id: scope.row.id}}">
                                    {{scope.row.name}}<br>
                                    ({{scope.row.type_memo}}<span v-for="(tag, index) in scope.row.tag" :key="index">/{{tag.tag_name}}</span>)<br>
                                </router-link>
                            </span>
                            <span v-if="scope.row.child > 0">
                                <CustomerChild v-if="isChild" ref="childMerge" :customerId="scope.row.id" :masterName="scope.row.name" :routePath="$route.path" @cancelMerge="handleCancelMerge($event)"></CustomerChild>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="products" label="申请/已购产品" width="180">
                        <template slot-scope="scope">
                            <div v-if="scope.row.apply_products">
                                【申请】<span style="color: red;">{{scope.row.apply_products}}</span>
                            </div>
                            <div v-if="scope.row.products.length">
                                <div v-if="scope.row.products.length == 1" class="product-buyed">
                                    <p>【{{scope.row.products[0].order_type_memo}}】{{scope.row.products[0].product_name}}
                                        <span style="color:red;" v-if="calculateExpireDay(scope.row.products[0].end_at) < 0">已到期</span>
                                        <span style="color:orange;" v-else-if="calculateExpireDay(scope.row.products[0].end_at) == 0">0天后到期</span>
                                        <span style="color:green;" v-else-if="calculateExpireDay(scope.row.products[0].end_at) < 10">{{calculateExpireDay(scope.row.products[0].end_at)}}天后到期</span>
                                    </p>
                                    <p>{{scope.row.products[0].start_at}}~{{scope.row.products[0].end_at}}</p>
                                </div>
                                <el-dropdown v-else>
                                    <span class="el-dropdown-link product-buyed">
                                        <p>【{{scope.row.products[0].order_type_memo}}】{{scope.row.products[0].product_name}}
                                            <span style="color:red;" v-if="calculateExpireDay(scope.row.products[0].end_at) < 0">已到期</span>
                                            <span style="color:orange;" v-else-if="calculateExpireDay(scope.row.products[0].end_at) == 0">0天后到期</span>
                                            <span style="color:green;" v-else-if="calculateExpireDay(scope.row.products[0].end_at) < 10">{{calculateExpireDay(scope.row.products[0].end_at)}}天后到期</span>
                                        </p>
                                        <p>{{scope.row.products[0].start_at}}~{{scope.row.products[0].end_at}}</p>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="product in _.orderBy(scope.row.products,['end_at','open_state'], ['desc', 'desc'])" :key="product.id">
                                            <p>【{{product.order_type_memo}}】{{product.product_name}}
                                                <span style="color:red;" v-if="calculateExpireDay(product.end_at) < 0">已到期</span>
                                                <span style="color:orange;" v-else-if="calculateExpireDay(product.end_at) == 0">0天后到期</span>
                                                <span style="color:green;" v-else-if="calculateExpireDay(product.end_at) < 10">{{calculateExpireDay(product.end_at)}}天后到期</span>
                                            </p>
                                            <p>{{product.start_at}}~{{product.end_at}}</p>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="level_name" scoped-slot width="80">
                        <template slot="header" slot-scope="scope">
                            级别
                            <el-tooltip placement="right">
                                <div slot="content">
                                    A:意向极高的客户<br />
                                    B:试用中客户,到期自动掉至C级<br />
                                    C:试用结束客户与其他客户<br />
                                    D:正式客户,全部产品到期自动掉至E级<br />
                                    E:断续客户<br />
                                </div>
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="last_trace_created_at" sortable="last_trace_created_at" label="最后跟进时间" width="150">
                        <template slot-scope="scope">
                            <el-tooltip v-if="scope.row.lastTrace" effect="light" :content="scope.row.lastTrace.content" placement="top">
                                <router-link :to="{ path: '/customers/view', query: {id: scope.row.id}}" style="color: #409EFF">
                                    {{scope.row.lastTrace.created_at}}
                                </router-link>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="next_time" sortable="next_time" label="下次跟进时间" width="150">
                        <template slot-scope="scope">
                            <span v-if="scope.row.lastTrace">
                                {{scope.row.lastTrace.next_time}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="searcherModel.active_name == 'public'" prop="unbind_at" sortable="unbind_at" label="解绑时间" width="150"></el-table-column>
                    <el-table-column prop="created_at" label="客户创建时间" width="150">
                        <template slot-scope="scope">
                            <span>
                                {{scope.row.created_at}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="district_names" label="所在地区">
                         <template slot-scope="scope">
                              <i v-if="scope.row.is_Lock == 1"
                                 class="el-icon-lock"
                                 style="color: rgb(239 6 6); margin-left: 5px; font-size: 12px;">
                              </i>
                             <span>{{ scope.row.district_names }}</span>

                         </template>
                    </el-table-column>
                    <el-table-column v-if="this.$route.path == '/customers/index'" prop="branch_name" label="所在部门" width="80"></el-table-column>
                    <el-table-column prop="user_name" label="业务员" width="120">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.user_id == 0" @click="saveBind(scope.row)" type="success" size="mini" :disabled="disabled">领取客户</el-button>
                            <span v-else-if="scope.row.user_id == $store.getters.userId">
                                <img :src="user_avatar" style="border:0px;border-radius:10px;-webkit-border-radius:10px;">
                                <el-button @click="showUnbindDialog(scope.row)" v-if="Acs('/customers/unbind')" type="text" size="mini" style="color: #F56C6C;font-weight: 900" class="el-icon-close"></el-button>
                            </span>
                            <span v-else>
                                {{scope.row.user_name}}
                                <el-button @click="showUnbindDialog(scope.row)" v-if="Acs('/customers/unbind')" type="text" size="mini" style="color: #F56C6C;font-weight: 900" class="el-icon-close"></el-button>
                            </span>
                            <div v-for="(cooperator, index) in scope.row.cooperator" :key="index">
                                {{cooperator.user_name}}(协作)<el-button @click="deleteCooperator(cooperator)" v-if="Acs('/customer-cooperator/delete')" type="text" size="mini" style="color: #F56C6C;font-weight: 900" class="el-icon-close"></el-button>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click="handleView(scope.row)" type="text" size="small">查看</el-button>
                            <el-button v-if="Acs('/customers/my_update')" @click="handleUpdateMyCustomer(scope.row)" type="text" size="small">编辑</el-button>
                            <el-button v-if="Acs('/customers/update')" @click="handleUpdate(scope.row)" type="text" size="small">编辑</el-button>
                            <el-button type="text" size="small" @click="showDeleteDialog(scope.row)" v-if="Acs('/customers/delete')">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <el-row v-if="linkPage">
                    <pagination :linkPage="linkPage"></pagination>
                </el-row>

                <trace-modal :show-dialog="showTraceModal" :customer-id="currentRow.id" @closeModal="closeModal"></trace-modal>
                <visit-modal :show-dialog="showVisitModal" :customer-id="currentRow.id" @closeModal="closeModal"></visit-modal>

                <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="20%" center>
                    <p style="text-align: center">{{dialogWarning}}</p>
                    <el-form :model="form">
                        <el-form-item label="业务员姓名">
                            <UserSelect1 v-model="form.user_id" @change="UserHandleChange"></UserSelect1>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="handleBind()" :loading="bind_loading">确 定</el-button>
                    </div>
                </el-dialog>

                <el-dialog :title="dialogTitle" :visible.sync="dialogFormMerge" width="40%">
                    <el-form :model="form">
                        <el-form-item label="合并客户">
                            <el-select style="width:100%" v-model="form.pid" placeholder="请选择合并主客户">
                                <el-option v-for="item in multipleSelectionCustomers" :key="item.id" :label="item.label" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <p>
                        <b>温馨提醒:</b><br/>
                        1.绑定业务员的客户不能作为子客户。<br>
                        2.不同一级地区的客户不支持合并。<br>
                    </p>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormMerge = false">取 消</el-button>
                        <el-button type="primary" @click="handleMerge()" :loading="loading">确 定</el-button>
                    </div>
                </el-dialog>

                <el-dialog :title="dialogTitle" :visible.sync="dialogFormDistrict" width="40%">
                    <el-form :model="form">
                        <el-form-item>
                            <DistrictLinkage ref="DistrictLinkage" labelName="修改所在地区" :provinceId="parseInt(form.province_id)" :cityId="parseInt(form.city_id)" :districtId="parseInt(form.district_id)" @change="handleChangeDistrict($event)"></DistrictLinkage>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormDistrict = false">取 消</el-button>
                        <el-button type="primary" @click="handleDistrict()" :loading="loading">确 定</el-button>
                    </div>
                </el-dialog>

                <query-repeat v-if="showQueryRepeat" :display="showQueryRepeat" @watchQueryRepeatClose="watchQueryRepeatClose"></query-repeat>

                <el-dialog title="删除客户" :visible.sync="dialogDelete" width="40%">
                    <el-form :model="form">
                        <el-form-item label="删除原因:">
                            <el-input type="textarea" v-model="form.memo" placeholder="请输入删除原因"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogDelete = false">取 消</el-button>
                        <el-button type="primary" @click="handleDelete()" :loading="loading">确 定</el-button>
                    </div>
                </el-dialog>

                <el-dialog title="导入协作人" :visible.sync="dialogImportCooperator" width="30%" center>
                    <el-form :model="importForm">
                        <el-form-item>
                            <el-input v-model="importForm.file" placeholder="选择文件" readonly>
                                <el-button slot="append" type="primary" @click="selectFile">选择文件 .xlsx</el-button>
                            </el-input>
                            <input ref="fileInput" type="file" accept=".xlsx" style="display: none" @change="handleFileChange" />
                        </el-form-item>
                        <el-form-item>
                            <el-button type="text" @click="downloadTemplate">协作人模板下载.xlsx</el-button>
                        </el-form-item>
                        <el-form-item>
                            <span style="color: red;">提示:一次最多导入2000个协作人</span>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogImportCooperator = false">取消</el-button>
                        <el-button type="primary" @click="handleImportCooperator" :loading="uploadLoading">确定</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
    import Function from "~/common/functions"; // 确保导入了这个工具类
    import Pagination from "~/widgets/Pagination.vue";
    import CustomerService from "~/services/customer";
    import CustomerCooperatorService from "~/services/CustomerCooperator";
    import TraceModal from "~/views/tasks/TraceModal.vue";
    import VisitModal from "~/views/tasks/VisitModal.vue";
    import UserSelect from "~/widgets/UserSelect.vue";
    import UserSelect1 from "~/widgets/UserSelectCorp.vue";
    import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
    import user_avatar from '~/assets/usre-icon.png';
    import QueryRepeat from "~/views/clue/dialog/QueryRepeat.vue";
    import CustomerChild from "~/widgets/CustomerChild.vue";
    import Product from "~/widgets/Product.vue";
    import Recycle from "~/views/customer/recycle.vue";
    import ExportFile from "~/widgets/ExportFile.vue";
    import SearchForm from "~/widgets/SearchForm.vue";

    export default {
        components: {
            UserSelect,
            UserSelect1,
            Pagination,
            TraceModal,
            VisitModal,
            DistrictLinkage,
            QueryRepeat,
            CustomerChild,
            Product,
            Recycle,
            ExportFile,
            SearchForm
        },
        data() {
            return {
                user_avatar: user_avatar,
                showQueryRepeat:false,
                searcherModel: {},
                customers: [],
                loading: true,
                // 分页信息
                linkPage: null,
                // 当前被点击处理的表格行记录
                currentRow: {},
                showTraceModal: false,
                showVisitModal: false,
                //客户绑定，删除
                form: {
                	customer_ids: [],
	                user_id: '',
                    pid:'',
                    province_id: 0,
                    city_id: 0,
                    district_id: 0,
                    memo: '',
                    sub_type: 1,
                },
	            dialogFormVisible: false,
                dialogFormMerge: false,
                dialogFormDistrict: false,
                dialogDelete: false,
	            dialogTitle: '',
                dialogWarning: '',
                //全选，全不选
                multipleSelection: [],
                multipleSelectionCustomers: [],
                disabled: false,
                // 是否禁用批量操作状态，它的状态依赖于 multipleSelection 中是否有被选中的记录
                disableBatchOption : true,
                isChild: true,
                search_form_key: 0,
                fields: [],
                bind_loading: false,
                dialogImportCooperator: false, // 导入协作人弹框
                importForm: {
                    file: null
                },
                uploadLoading: false,
            };
        },

        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {
            this.searcherModel['page'] = to.query["page"];
            this.searcherModel['perPage'] = to.query["perPage"];
            this.submitSearch();
        },
        created: function () {
	        this.dialogTitle = (this.$route.path == '/customer/my-index')?this.title1:this.title2;
            this.resetForm();
            if(!this.Acs('/customers/bind')) {
                this.disabled = true;
                return;
            }
            if (this.multipleSelection.length > 0) {
                this.disableBatchOption = false;
            }
        },

        //监听$route, 路由有变化时，重载列表。
        watch: {
            multipleSelection: function (value, oldValue) {
                if (value.length > 0) {
                    this.disableBatchOption = false;
                } else {
                    this.disableBatchOption = true;
                }
            },
            $route: function (value, oldValue) {
	            this.dialogTitle = (this.$route.path == '/customer/my-index')?this.title1:this.title2;
                this.searcherModel.active_name = this.$route.path == '/customers/index' ? 'index' : 'public';
                // this.searcherModel['page'] = to.query["page"];
                // this.searcherModel['perPage'] = to.query["perPage"];
                this.resetForm();
            },
        },
        destroyed(){
            delete localStorage['/customers/index'+this.$store.getters.token];
            delete localStorage['/customers/public'+this.$store.getters.token];
        },
        methods: {
            calculateExpireDay(end_at) {
                if (!end_at) return 0;

                // 解析结束日期 (格式: YYYY-MM-DD)
                const endDate = new Date(end_at.replace(/-/g, "/"));
                endDate.setHours(0, 0, 0, 0); // 设置为当天开始时间

                // 获取当前日期
                const today = new Date();
                today.setHours(0, 0, 0, 0); // 设置为当天开始

                // 计算天数差异 - 使用floor而不是ceil确保准确的天数
                const diffTime = endDate.getTime() - today.getTime();
                const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

                return diffDays;
            },

            watchQueryRepeatClose() {
                this.showQueryRepeat = false;
            },

            // 客户列表展示
            initListData(params = {}) {
                // loading 动画
                this.loading = true;
                let can_delete = true;
                let all_customer = true;
                let my_customer = true;
                let dtd;
                if (this.$route.path == '/customers/my-index') {
                    //我的客户
                    dtd = CustomerService.getMyList(params);
                    can_delete = false;
                    all_customer = false;
                } else if(this.$route.path == '/customers/public') {
                    dtd = CustomerService.getPublicList(params);
                    can_delete = false;
                    my_customer = false;
	                all_customer = false;
                } else {
                    dtd = CustomerService.getList(params);
                    my_customer = false;
                }
                dtd.then(res => {
                    this.customers =  _.map(res.data, (item) => {
                        item.can_delete = can_delete;
                        item.all_customer = all_customer;
                        item.my_customer = my_customer;
                        return item;
                    });
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                    this.loading = false;
                })

            },

            // 筛选查询
            submitSearch(params = null, $data = null) {
                if($data && typeof $data.order !== undefined){
                    this.searcherModel.sort_name = $data['prop'];
                    this.searcherModel.sort_by = $data['order'];
                }
                if(params){
                    this.searcherModel = params;
                }
                params = _.clone(this.searcherModel);
                _.each(params, (val, key) => {
                    // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                    if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                        delete params[key];
                    }
                })
                this.initListData(params);
            },

            searcherModelInit(){
                this.searcherModel = {
                    id: '',
                    name: '',
                    type: '',
                    username: '',
                    province_id: 0,
                    city_id: 0,
                    district_id: 0,
                    product_id: '',
                    level: '',
                    is_bind: '',
                    origin:'',
                    product_type: '',
                    sort_name:'',
                    sort_by:'',
                    time_status: '',
                    customer_ids: [],
                    child: '',
                    branch_id: '',
                    stop_renew: '',
                    key_word: '',
                    cooperator_id: '',
                    down_num: '',
                    subject_num: '',
                    is_mobile: '',
                    stages: [],
                    formal_status: '',
                    time_type: 1,
                    create_times: [],
                    traceTimes: [],
                    nextTimes:[],
                    product_times:[],
                    unbind_times: [],
                    active_name: this.searcherModel.active_name ? this.searcherModel.active_name : (this.$route.path == '/customers/index' ? 'index' : 'public'),
                    is_overtime: '',
                    unbind_type: '',
                    repay_type: 0,
                    tag: '',
                };
            },
            // 重置筛选表单
            resetForm() {
                this.searcherModelInit();
                this.searcherModel = Object.assign({}, this.searcherModel, this.$route.query);
                this.searcherModel.create_times = this.$route.query['created_at'] ? this.$route.query['created_at'] : [];
                this.searcherModel.product_type = this.searcherModel.product_type > 0 ? parseInt(this.searcherModel.product_type) : '';
                delete this.searcherModel.created_at;
                this.fields = CustomerService.getFields(this.$route.path, this.searcherModel.active_name);
                this.search_form_key ++;
                this.submitSearch();
            },

            handleView(customer) {
                let routeData = this.$router.resolve({
                    path: "/customers/view",
                    query: { id: customer.id },
                });
                window.open(routeData.href, '_blank');
            },

            handleUpdate(customer) {
                if(this.$route.path == '/customers/public') {
                    let routeData = this.$router.resolve({
                        path: "/customers/update",
                        query: { id: customer.id, public: 1, from: 'public'},
                    });
                    window.open(routeData.href, '_blank');
                } else {
                    let routeData = this.$router.resolve({
                        path: "/customers/update",
                        query: { id: customer.id, from: 'index'},
                    });
                    window.open(routeData.href, '_blank');
                }
            },

            handleUpdateMyCustomer(customer) {
                let routeData = this.$router.resolve({
                    path: "/customers/view",
                    query: { id: customer.id },
                });
                window.open(routeData.href, '_blank');
            },


	        //展示批量绑定客户对话框
	        showBatchBindDialog(sub_type) {
                let t = this.resDialog();
                if (!t) return false;
                this.dialogTitle = sub_type == 2 ? '批量转交客户' : '批量绑定';
                this.dialogWarning = sub_type == 2 ? '同时接管客户订单中绑定客户业务员参与的部分' : '';
                this.form.sub_type = sub_type;
                this.form.customer_ids = this.multipleSelection;
                this.dialogFormVisible = true;
            },


            //合并客户
	        showBatchMergeDialog() {
                if (this.multipleSelection.length <= 1) {
			        this.$message({
				        message: '选择客户数量不能小于2个',
				        type: 'error'
			        });
			        return false;
                }
		        this.dialogFormMerge = true;
		        this.form.customer_ids = [];
                this.form.pid = '';
                this.form.customer_ids = this.multipleSelection;
            },

            showBatchDistrictDialog() {
                let t = this.resDialog();
                if (!t) return false;
                this.dialogFormDistrict = true;
                this.form.customer_ids = [];
                this.form.customer_ids = this.multipleSelection;
            },

            /**
             * 处理绑定逻辑
             * Simon: 产品提出新需求要求绑定只可绑定给自己
             * @param customer
             */
            saveBind(customer) {

                this.$confirm("确定要绑定该客户吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                }).then(() => {

                    let userId = this.$store.getters.userId;
                    if (userId > 0)  {
                        this.form.user_id = userId;
                    }
                    this.form.customer_ids = [customer.id];
                    CustomerService.bind(this.form).then(res => {
                        if (res.code == 0) {
                            alert('领取成功');
                            this.submitSearch();
                        }
                    });
                }).catch(() => {});
            },

            //绑定客户
	        handleBind() {
                this.bind_loading = true;
                let customer_service = null;
                if(this.form.sub_type == 2){
                    customer_service = CustomerService.takeOver(this.form);
                }else{
                    customer_service = CustomerService.bind(this.form);
                }
		        customer_service.then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: "操作成功",
                            type: "success"
                        });
                        this.submitSearch();
                    }
                    this.bind_loading = false;
                    this.dialogFormVisible = false;
		        });
            },
            //合并客户
	        handleMerge() {
                if (this.form.pid <= 0) {
			        this.$message({
				        message: '请先选择合并主客户',
				        type: 'error'
			        });
			        return false;
                }
                this.loading = true;
                CustomerService.merge(this.form).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: "合并成功",
                            type: "success"
                        });
                        this.submitSearch();
                        this.isChild = false;
                        this.$nextTick(() => (this.isChild = true));
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
                this.dialogFormMerge = false;
            },

            //修改地区
	        handleDistrict() {
                if (this.form.province_id <= 0 || this.form.city_id <= 0 || this.form.district_id <= 0) {
			        this.$message({
				        message: '请先选择完整地区',
				        type: 'error'
			        });
			        return false;
                }
                this.loading = true;
                CustomerService.changeArea(this.form).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: "修改成功",
                            type: "success"
                        });
                        this.submitSearch();
                    } else {
                        this.$message({
                            message: '修改失败：' + res.msg,
                            type: "error"
                        });
                    }
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
                this.dialogFormDistrict = false;
            },

            // 通用提示
            resDialog() {
                if (this.multipleSelection.length <= 0) {
			        this.$message({
				        message: '对不起，请先选择要操作的客户数据',
				        type: 'error'
			        });
			        return false;
                }
                return true;
            },

            //删除客户的提示和数据处理。
            showDeleteDialog(customer) {
                this.form.customer_ids = [];
                this.form.customer_ids.push(customer.id);
                this.dialogDelete = true;
            },

            //展示批量删除客户对话框
	        showBatchDeleteDialog() {
                this.form.customer_ids = [];
                this.form.customer_ids = this.multipleSelection;
                this.dialogDelete = true;
	        },

	        //解绑客户的提示和数据处理。
	        showUnbindDialog(customer) {
		        this.$confirm("您确定要解绑该客户吗？解绑后，客户将会进入客户公海池被其他人绑定哦", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                }).then(() => {
			        this.form.customer_ids = [];
			        this.form.customer_ids.push(customer.id);
                    this.handleUnbind();

		        }).catch(() => {});
            },


	        //批量解绑客户的提示和数据处理。
	        showBatchUnbindDialog(customer) {
                let t = this.resDialog();
                if (!t) return false;
                this.$confirm("您确定要解绑选中客户吗？解绑后，客户将会进入客户公海池被其他人绑定哦", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                }).then(() =>{
                    this.form.customer_ids = [];
                    this.form.customer_ids = this.multipleSelection;
                    this.handleUnbind();
                    this.submitSearch();
                });

            },

            //解绑客户
	        handleUnbind() {
		        CustomerService.unbind({'customer_ids':this.form.customer_ids}).then(res => {
                    let form = this.form;
                    this.resp_alert(res, '解绑成功', res => {
                        this.customers.map(function(customer, index) {
                            form.customer_ids.map(function(customer_id, index){
                                if (customer.id == customer_id) {
                                    customer.user_id = 0;
                                    customer.user_name = '';
                                }
                            });
                        });
                    });
		        });
            },

            //删除客户
            handleDelete() {
                this.loading = true;
                CustomerService.delete(this.form).then(res => {
                    let form = this.form;
                    this.resp_alert(res, '删除成功', res => {
                        form.customer_ids.forEach(customer_id => {
                            this.customers = this.customers.filter( customer => {
                                return customer_id != customer.id;
                            })
                        });
                    });
                    this.dialogDelete = false;
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            },

            // 监听对话框关闭事件
            closeModal(isShow) {
                this.showTraceModal = isShow;
                this.showVisitModal = isShow;
                //this.isFinished = isShow;
                this.submitSearch();
            },

	        //业务员姓名远程搜索组件赋值
	        UserHandleChange(value) {
		        this.form.user_id = value;
            },


            //地区联动 Cascader 级联选择器,切换事件,表单model赋值
            handleChangeDistrict(value) {
                this.form.province_id = parseInt(value[0]);
                this.form.city_id = parseInt(value[1]);
                this.form.district_id = parseInt(value[2]);
            },

            //取消合并
            handleCancelMerge(value) {
                this.submitSearch();
            },

            //全选，全不选
	        handleSelectionChange(customers) {
		        this.multipleSelection = [];
                this.multipleSelectionCustomers = [];
		        customers.forEach(row => {
			        this.multipleSelection.push(row.id);
                    this.$set(row, 'is_master', 0);
                    this.$set(row, 'label', row.name + '（id:' + row.id + '）最后跟进时间：' + row.last_trace_created_at);
                    this.multipleSelectionCustomers.push(row);
                });
            },

            addCustomer() {
                this.$router.push({
                    path: "/customers/create",
                    query: {
                        from: 'index',
                    }
                })
            },

            handleClick(tab, event) {
                if(this.searcherModel.active_name != 'recycle'){
                    this.resetForm();
                }
            },

            deleteCooperator(obj){
                this.$confirm("确定要解除协作人吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                }).then(() => {
                    CustomerCooperatorService.delete(obj.id).then(res => {
                        if(res && res.code == 0){
                            this.resp_alert(res, '操作成功', res => {
                                this.customers.map(function(customer, index) {
                                    if(obj.customer_id == customer.id){
                                        customer.cooperator = customer.cooperator.filter(function(item, key){
                                            return item.id != obj.id;
                                        });
                                    }
                                });
                            });
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    }).catch((err) => {
                        console.error(err);
                    });
                })
            },
            // 显示导入协作人弹框
            showImportCooperatorDialog() {
                this.importForm.file = null;
                this.dialogImportCooperator = true;
            },

            // 触发文件选择
            selectFile() {
                this.$refs.fileInput.click();
            },

            // 文件选择变化
            handleFileChange(event) {
                const file = event.target.files[0];
                if (file) {
                    // 验证文件类型
                    if (!file.name.endsWith('.xlsx')) {
                        this.$message.error('请选择 .xlsx 格式的文件');
                        return;
                    }
                    this.importForm.file = file.name;
                    this.selectedFile = file;
                }
            },


            // 下载模板方法
           downloadTemplate() {
               let url = 'api/customer-cooperator/cooprator-example-export';
               let params = {}; // 如果需要参数可以添加
               Function.exportFile(url, params);
           },


            // 执行导入
           handleImportCooperator() {
               if (!this.selectedFile) {
                   this.$message.error('请先选择文件');
                   return;
               }

               this.uploadLoading = true;
               const formData = new FormData();
               formData.append('file', this.selectedFile);

               // 调用 CustomerAccounts 的导入接口
               CustomerCooperatorService.importCooprator(formData).then(res => {
                   if (res.code == 0) {
                       this.$message.success('导入成功');
                       this.dialogImportCooperator = false;
                       this.submitSearch(); // 刷新列表
                   }
                   this.uploadLoading = false;
               }).catch(err => {
                   console.error('导入失败:', err);
                   this.$message.error('导入失败');
                   this.uploadLoading = false;
               });
           }


        }
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .customer-name {
        cursor: pointer;
    }

    .customer-name:hover {
        color: #409EFF;
    }
</style>



// WEBPACK FOOTER //
// src/views/customer/index.vue